module.exports = __webpack_public_path__ + "static/media/logo-exaleap.98a57c97.jpg";